import { Spine } from '@esotericsoftware/spine-pixi'

export function playSpine(spine: Spine, animation: string, loop = false) {
  return new Promise<void>((resolve) => {
    const track = spine.state.setAnimation(0, animation, loop)
    if (!loop) {
      setTimeout(() => {
        resolve()
      }, track.animation?.duration as number * 1000)
    }
    else {
      resolve()
    }
  })
}

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
